export default "__VITE_ASSET__nkme6bUE__"